'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var Link = require('../../../react-router-dom/Link/Link.cjs');
require('@remix-run/react');
require('react-router-dom');
require('react');
var InternalButtonLink_web_styles = require('./InternalButtonLink.web.styles.cjs');

/**
 * Unstyled component that renders `a` or `button` element,
 * depending on the props passed in
 *
 * @scope Web, Internal
 *
 */ const InternalButtonLink = ({ children, href, type, to, onClick, replace, innerRef, isPending = false, css, ...rest })=>{
    const linkStyles = [
        InternalButtonLink_web_styles.base,
        InternalButtonLink_web_styles.noStyleLink,
        css
    ];
    const isExternal = ()=>{
        if (href) {
            return href.includes("www") || href.includes("http");
        }
    };
    const getValidButtonType = ()=>{
        if (type === "submit" || type === "reset") {
            return type;
        } else {
            return "button";
        }
    };
    // Using a button instead of an anchor tag with a role of button here
    // Adding `role="button"` tells screen readers that it's a button, but does not provide button functionality and is not keyboard accessible
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role
    const renderNoStyleButton = ()=>{
        const resetDefaultStyles = [
            InternalButtonLink_web_styles.base,
            InternalButtonLink_web_styles.noStyleButton,
            isPending && InternalButtonLink_web_styles.loading
        ];
        const renderSpinner = ()=>{
            if (!isPending) return null;
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: InternalButtonLink_web_styles.spinnerContainer,
                children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                    css: InternalButtonLink_web_styles.spinner,
                    icon: index.faSpinnerThird,
                    spin: true,
                    title: "Loading"
                })
            });
        };
        return /*#__PURE__*/ jsxRuntime.jsxs("button", {
            css: [
                resetDefaultStyles,
                css
            ],
            ref: innerRef,
            type: getValidButtonType(),
            onClick: onClick,
            ...rest,
            children: [
                renderSpinner(),
                children
            ]
        });
    };
    const options = {
        ...isExternal() && {
            target: "_blank",
            rel: "noreferrer noopener"
        }
    };
    const renderAnchor = ()=>/*#__PURE__*/ jsxRuntime.jsx("a", {
            href: href,
            onClick: onClick,
            css: linkStyles,
            ...options,
            ...rest,
            ref: innerRef,
            children: children
        });
    const renderRouterLink = ()=>/*#__PURE__*/ jsxRuntime.jsx(Link.Link, {
            to: to,
            onClick: onClick,
            replace: replace,
            "data-testid": "router-link",
            css: css,
            ...rest,
            // @ts-expect-error for some reason the ref type is not being inferred correctly from the RouterLink
            ref: innerRef,
            children: children
        });
    const getElement = ()=>{
        if (!to && !href) {
            return renderNoStyleButton();
        } else if (to) {
            return renderRouterLink();
        }
        return renderAnchor();
    };
    return getElement();
};

exports.InternalButtonLink = InternalButtonLink;
//# sourceMappingURL=InternalButtonLink.web.cjs.map
